export const ID13 = () => {
    return(
        <div>
            <h2 className="servicePage_title">1C:УПРАВЛЕНИЕ ПРОЕКТАМИ</h2>
            <div className="content" readonly=""><h1>1С:PM Управление проектами ПРОФ</h1>

                <h2>Работы, сроки и содержание проекта</h2>
                <ul>
                    <li>формирование списка проектов</li>
                    <li>планирование содержания и сроков работ</li>
                    <li>ввод фактических данных о текущем статусе проекта и проценте выполнения работ</li>
                    <li>управление версиями проекта</li>
                    <li>актуализация проекта</li>
                    <li>управление документами проекта</li>
                    <li>управление проектными знаниями</li>
                    <li>контроль выполнения проектных задач</li>
                    <li>анализ соответствия плановых и фактических показателей</li>
                    <li>анализ проектов с группировкой по портфелям и программам</li>
                </ul>

                <h2>Проектное бюджетирование</h2>
                <ul>
                    <li>планирование доходов, расходов, поступлений и выплат по проекту</li>
                    <li>регистрация фактических данных и актуализация бюджета проекта</li>
                    <li>планирование данных выпускаемых объемов и регистрация фактических объемов</li>
                    <li>регистрация состояния и процента выполнения проектных работ</li>
                    <li>
                        графический и табличный анализ доходов, расходов, маржинальности, поступлений, выплат, денежного
                        потока, выполненных выпускаемых объемов, готовности
                        проекта, сроков выполнения, состояния показателей проектов и проектных работ
                    </li>
                </ul>

                <h2>Ресурсы проектов</h2>
                <ul>
                    <li>планирование трудозатрат по ролям</li>
                    <li>управление загрузкой и рабочим временем</li>
                    <li>управление трудовыми и материальными ресурсами</li>
                    <li>учет внутренних работ проектного офиса</li>
                </ul>

                <h2>Работа подразделений</h2>
                <ul>
                    <li>планирование и анализ загрузки подразделений по ролям и трудовым ресурсам</li>
                    <li>планирование и анализ финансовых показателей работы подразделений</li>
                </ul>

                <h2>Сводный план (тематический план, производственная программа)</h2>
                <ul>
                    <li>формирование годового сводного плана по проектам</li>
                    <li>анализ доступности ресурсов по сводному плану</li>
                    <li>план-фактный анализ исполнения сводного плана</li>
                </ul>

                <h2>ТМЦ</h2>
                <ul>
                    <li>планирование материальных затрат проекта</li>
                    <li>учет фактических затрат по материальным ресурсам</li>
                </ul>

                <h2>Субподрядчики</h2>
                <ul>
                    <li>планирование субподрядных работ проекта</li>
                    <li>оценка исполнителей и субподрядчиков по проектам и работам проектов</li>
                </ul>

                <h2>Интеграционные возможности и технологические преимущества</h2>
                <p>
                    <b>Интеграционные возможности</b>
                </p>
                <p>Реализованы интеграции между "1С:PM Управление проектами ПРОФ" со следующими программными
                    продуктами:</p>
                <ul>
                    <li>Обмен данными с Microsoft Project: доступен импорт и экспорт планов, сроков и ресурсов
                        проектов;
                    </li>
                    <li>
                        Интеграция с Битрикс24: передача из "1С:PM Управление проектами ПРОФ" в Битрикс24 структуры
                        плана проекта, передача из Битрикс24 в "1С:PM Управление
                        проектами ПРОФ" факта часов, статуса задач и новых заданий;
                    </li>
                    <li>
                        Интеграция с "1С:Документооборот": регистрация документов, запуск бизнес–процессов с
                        возможностью присоединять внутренние документы к проектам, задачам
                        и документам факта;
                    </li>
                    <li>Обмен данными с "1С:PM Управление проектами": доступен импорт и экспорт планов, сроков и
                        ресурсов проектов;
                    </li>
                    <li>
                        Обмен данными с "1С:Бухгалтерия предприятия": выгрузка сводной информации из "1С:Бухгалтерия
                        предприятия" в "1С:PM Управление проектами ПРОФ" с целью
                        получения фактических данных по БДР, БДДС проектов;
                    </li>
                    <li>Загрузка смет из "1С:Смета" и других сметных решений, поддерживающих формат *.arp;</li>
                    <li>Витрина данных для "1С:Аналитика": регистр для консолидации проектных данных с целью вывода на
                        витрину "1С:Аналитика".
                    </li>
                </ul>

                <p>
                    <b>Технологические преимущества</b>
                </p>

                <p>Решение "1С:PM Управление проектами ПРОФ" разработано на новейшей версии технологической платформы
                    "1С:Предприятие 8.3", которая позволяет:</p>

                <ul>
                    <li>обеспечить высокую надежность, производительность и масштабируемость системы;</li>
                    <li>
                        организовать работу с системой через Интернет, в режиме тонкого клиента или веб-клиент (через
                        обычный интернет-браузер), в том числе в "облачном"
                        режиме;
                    </li>
                    <li>создавать мобильные рабочие места с использованием планшетов и иных мобильных устройств;</li>
                    <li>настраивать интерфейс для конкретного пользователя или группы пользователей с учетом роли
                        пользователя, его прав доступа и индивидуальных настроек.
                    </li>
                </ul>

                <p>
                    Механизм функциональных опций, реализованный в "1С:PM Управление проектами ПРОФ", позволяет
                    включать/выключать различные функциональные части прикладного
                    решения без программирования (изменения конфигурации).
                </p></div>
        </div>
    )
}